import { Navbar } from "@/components/gym/Navbar";
import { Hero } from "@/components/gym/Hero";
import { About } from "@/components/gym/About";
import { WhyChooseUs } from "@/components/gym/WhyChooseUs";
import { Pricing } from "@/components/gym/Pricing";
import { Gallery } from "@/components/gym/Gallery";
import { Visit } from "@/components/gym/Visit";
import { Footer } from "@/components/gym/Footer";
import { FloatingWhatsApp } from "@/components/gym/FloatingWhatsApp";

export default function Landing() {
  return (
    <div className="bg-obsidian text-white min-h-screen" data-testid="landing-page">
      <div className="grain-overlay" aria-hidden="true" />
      <Navbar />
      <main>
        <Hero />
        <About />
        <WhyChooseUs />
        <Pricing />
        <Gallery />
        <Visit />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
